import { Spacings } from "react-native-ui-lib";
import {
  BarcodeFocusOverlay,
  BarcodeFocusOverlayProps,
} from "../BarcodeFocusOverlay";
import { View } from "react-native";
import { Button, useThemeProvider } from "@towersystems/roam-common-native";

export interface BarcodeScannerOverlayProps extends BarcodeFocusOverlayProps {
  onCancel: () => void;
}

export function BarcodeScannerOverlay({
  onCancel,
  ...overlayProps
}: BarcodeScannerOverlayProps) {
  const { colors } = useThemeProvider();

  return (
    <BarcodeFocusOverlay {...overlayProps}>
      <View
        style={{
          position: "absolute",
          bottom: Spacings.s5,
          left: Spacings.s5,
          right: Spacings.s5,
        }}
      >
        <Button
          onPress={onCancel}
          fullWidth
          variant="outline"
          labelStyle={{ color: colors.white }}
          label="Cancel"
        />
      </View>
    </BarcodeFocusOverlay>
  );
}
